/**
 * Baby G.O.A.T. Apparels Theme JavaScript
 * Lightweight vanilla JavaScript
 */

(function () {
  'use strict';

  // --- Mobile Drawer & Accordion Navigation ---
  function initMobileNav() {
    const drawer = document.querySelector('.mobile-nav-drawer');
    const openBtns = document.querySelectorAll('[data-action="open-mobile-nav"]');
    const closeBtns = document.querySelectorAll('[data-action="close-mobile-nav"]');

    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    openBtns.forEach(btn => btn.addEventListener('click', openDrawer));
    closeBtns.forEach(btn => btn.addEventListener('click', closeDrawer));

    // Backdrop click
    const backdrop = drawer.querySelector('.mobile-nav-drawer__backdrop');
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-active')) {
        closeDrawer();
      }
    });

    // Accordion Toggle Logic (Supports multi-level nesting & self-closing)
    const accordionTriggers = drawer.querySelectorAll('.js-accordion-trigger');
    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const parentItem = this.closest('.mobile-accordion__item') || this.closest('.mobile-accordion__subitem');
        if (!parentItem) return;

        const isOpen = parentItem.classList.contains('is-open');

        // Close sibling items at the same level (optional clean behavior)
        const siblings = parentItem.parentElement.children;
        Array.from(siblings).forEach(sib => {
          if (sib !== parentItem && (sib.classList.contains('mobile-accordion__item') || sib.classList.contains('mobile-accordion__subitem'))) {
            sib.classList.remove('is-open');
          }
        });

        // Toggle current item: if already open, close it!
        if (isOpen) {
          parentItem.classList.remove('is-open');
        } else {
          parentItem.classList.add('is-open');
        }
      });
    });
  }

  // --- Slideshow Carousel ---
  function initSlideshow() {
    const slideshows = document.querySelectorAll('.slideshow');

    slideshows.forEach(slideshow => {
      if (slideshow.dataset.initialized === 'true') return;
      slideshow.dataset.initialized = 'true';

      const track = slideshow.querySelector('.slideshow__track');
      const originalSlides = slideshow.querySelectorAll('.slideshow__slide:not(.slideshow__slide--clone)');
      const prevBtn = slideshow.querySelector('.slideshow__nav-btn--prev');
      const nextBtn = slideshow.querySelector('.slideshow__nav-btn--next');
      const dots = slideshow.querySelectorAll('.slideshow__dot');

      if (!track || originalSlides.length <= 1) return;

      const totalSlides = originalSlides.length;

      // Clean up previous clones if any
      track.querySelectorAll('.slideshow__slide--clone').forEach(c => c.remove());

      // First slide ka clone end mein add karein
      const firstClone = originalSlides[0].cloneNode(true);
      firstClone.classList.add('slideshow__slide--clone');
      firstClone.setAttribute('aria-hidden', 'true');
      track.appendChild(firstClone);

      let currentIndex = 0;
      let autoplayInterval = null;

      function updateDots(index) {
        const realIndex = index % totalSlides;

        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === realIndex);
        });
      }

      function updateSlide(index, animate = true) {
        currentIndex = index;

        if (!animate) {
          track.style.transition = 'none';
        } else {
          track.style.transition = 'transform 0.5s ease-in-out';
        }

        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        updateDots(currentIndex);
      }

      function goNext() {
        if (currentIndex >= totalSlides) {
          // Clone par pohanch chuke hain ya aage nikal gaye hain, silently reset to slide 0
          updateSlide(0, false);
          void track.offsetWidth; // Force layout recalculation
          updateSlide(1, true);
        } else {
          updateSlide(currentIndex + 1, true);
        }
      }

      function goPrev() {
        if (currentIndex <= 0) {
          // Snap silently to clone
          updateSlide(totalSlides, false);
          void track.offsetWidth; // Force layout recalculation
          updateSlide(totalSlides - 1, true);
        } else {
          updateSlide(currentIndex - 1, true);
        }
      }

      // Transition end event for seamless clone wrap
      track.addEventListener('transitionend', (e) => {
        if (e.target !== track || e.propertyName !== 'transform') return;

        if (currentIndex >= totalSlides) {
          updateSlide(0, false);
          void track.offsetWidth;
        }
      });

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          goNext();
          resetAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          goPrev();
          resetAutoplay();
        });
      }

      dots.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          updateSlide(idx, true);
          resetAutoplay();
        });
      });

      let touchStartX = 0;
      let touchEndX = 0;

      slideshow.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      slideshow.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;

        if (touchEndX < touchStartX - 40) {
          goNext();
          resetAutoplay();
        } else if (touchEndX > touchStartX + 40) {
          goPrev();
          resetAutoplay();
        }
      }, { passive: true });

      const autorotate = slideshow.dataset.autorotate === 'true' || slideshow.dataset.autorotate === true;
      const speed = parseInt(slideshow.dataset.speed, 10) || 3000;

      function startAutoplay() {
        if (autorotate && !autoplayInterval) {
          autoplayInterval = setInterval(() => {
            goNext();
          }, speed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      startAutoplay();

      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);

      // Handle tab visibility change so timers don't drift or push slide off-screen
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          if (currentIndex >= totalSlides) {
            updateSlide(0, false);
          }
          resetAutoplay();
        }
      });
    });
  }

  // --- Horizontal Carousel (Category / Collection Strip) with Auto-Slider ---
  function initCarousels() {
    const carousels = document.querySelectorAll('.js-carousel');

    carousels.forEach(carousel => {
      const wrapper = carousel.querySelector('.js-carousel-wrapper');
      const prevBtn = carousel.querySelector('.js-carousel-prev');
      const nextBtn = carousel.querySelector('.js-carousel-next');

      if (!wrapper) return;

      const scrollAmount = 260;

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      // Auto-Slider (Infinite Auto Scroll)
      let autoScrollTimer = null;

      function startAutoScroll() {
        if (!autoScrollTimer) {
          autoScrollTimer = setInterval(() => {
            const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
            if (wrapper.scrollLeft >= maxScrollLeft - 15) {
              wrapper.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            }
          }, 2800);
        }
      }

      function stopAutoScroll() {
        if (autoScrollTimer) {
          clearInterval(autoScrollTimer);
          autoScrollTimer = null;
        }
      }

      startAutoScroll();
      carousel.addEventListener('mouseenter', stopAutoScroll);
      carousel.addEventListener('mouseleave', startAutoScroll);
      carousel.addEventListener('touchstart', stopAutoScroll, { passive: true });
    });
  }

  // --- Cart Slide-out Drawer & Ajax Add to Cart ---
  function initCart() {
    const cartDrawer = document.querySelector('.cart-drawer');
    const openCartBtns = document.querySelectorAll('[data-action="open-cart"]');
    const closeCartBtns = document.querySelectorAll('[data-action="close-cart"]');
    const cartBadges = document.querySelectorAll('.site-header__cart-badge');

    function openCart() {
      if (!cartDrawer) return;
      cartDrawer.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }

    function closeCart() {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    openCartBtns.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    }));

    closeCartBtns.forEach(btn => btn.addEventListener('click', closeCart));

    if (cartDrawer) {
      const backdrop = cartDrawer.querySelector('.cart-drawer__backdrop');
      if (backdrop) backdrop.addEventListener('click', closeCart);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && cartDrawer.classList.contains('is-active')) {
          closeCart();
        }
      });
    }

    // Ajax add to cart
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('.product-card__form, form[action="/cart/add"]');
      if (!form || !cartDrawer) return;

      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn ? submitBtn.innerText : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = 'Adding...';
      }

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(res => res.json())
        .then(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerText = originalText;
          }
          openCart();
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerText = originalText;
          }
        });
    });

    // Fetch and render updated cart contents
    function fetchCart() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateCartBadge(cart.item_count);
          renderCartItems(cart);
        })
        .catch(err => console.error('Error fetching cart:', err));
    }

    function updateCartBadge(count) {
      cartBadges.forEach(badge => {
        badge.innerText = count;
      });
    }

    function renderCartItems(cart) {
      if (!cartDrawer) return;
      const itemsContainer = cartDrawer.querySelector('.cart-drawer__items');
      const subtotalEl = cartDrawer.querySelector('.cart-drawer__subtotal-value');
      const emptyNotice = cartDrawer.querySelector('.cart-drawer__empty');

      if (subtotalEl) {
        subtotalEl.innerText = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });
      }

      if (!itemsContainer) return;

      if (cart.item_count === 0) {
        if (emptyNotice) emptyNotice.style.display = 'block';
        itemsContainer.innerHTML = '<div style="text-align:center; padding: 2rem; color: #64748B;">Your cart is empty.</div>';
        return;
      }

      if (emptyNotice) emptyNotice.style.display = 'none';

      let html = '';
      cart.items.forEach(item => {
        const itemPrice = (item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency || 'USD' });
        html += `
          <div class="cart-item" data-line="${item.key}">
            <div class="cart-item__image-wrap">
              <img src="${item.image || ''}" alt="${item.title}" class="cart-item__image" />
            </div>
            <div class="cart-item__details">
              <h4 class="cart-item__title">${item.product_title}</h4>
              ${item.variant_title ? `<div style="font-size:0.75rem; color:#64748B;">${item.variant_title}</div>` : ''}
              <div class="cart-item__price">${itemPrice}</div>
              <div class="cart-item__qty">
                <span style="font-size:0.8rem; color:#64748B;">Qty: ${item.quantity}</span>
              </div>
            </div>
          </div>
        `;
      });

      itemsContainer.innerHTML = html;
    }
  }

  // --- Category Strip Infinite Auto-Slider ---
  function initCategoryStripSlider() {
    const strips = document.querySelectorAll('.category-strip');

    strips.forEach(strip => {
      const wrapper = strip.querySelector('.js-category-strip-wrapper');
      const track = strip.querySelector('.js-category-strip-track');
      if (!wrapper || !track) return;

      // Clean up previous clones if re-init
      track.querySelectorAll('.is-clone').forEach(el => el.remove());

      const originalItems = Array.from(track.querySelectorAll('.category-strip__item'));
      if (originalItems.length === 0) return;

      // Ensure hide scrollbars programmatically as well
      wrapper.style.scrollbarWidth = 'none';

      // Clone items twice to create a seamless 3-set infinite loop buffer
      for (let c = 0; c < 2; c++) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          const cloneLink = clone.tagName === 'A' ? clone : clone.querySelector('a');
          if (cloneLink) cloneLink.setAttribute('tabindex', '-1');
          track.appendChild(clone);
        });
      }

      let originalSetWidth = 0;

      function measureWidth() {
        const firstClone = track.querySelector('.is-clone');
        if (firstClone && originalItems[0]) {
          originalSetWidth = firstClone.offsetLeft - originalItems[0].offsetLeft;
        } else {
          originalSetWidth = originalItems.reduce((acc, el) => acc + el.offsetWidth + 24, 0);
        }
      }

      measureWidth();
      window.addEventListener('resize', measureWidth, { passive: true });
      window.addEventListener('load', measureWidth, { passive: true });

      let currentScrollPos = wrapper.scrollLeft;
      let isPaused = false;
      let isInteracting = false;
      let resumeTimer = null;
      const speed = 0.75; // Smooth drifting speed in px per frame
      let animationFrameId = null;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function loop() {
        if (!isPaused && !isInteracting && !prefersReducedMotion && originalSetWidth > 0) {
          currentScrollPos += speed;

          if (currentScrollPos >= originalSetWidth) {
            currentScrollPos -= originalSetWidth;
          } else if (currentScrollPos < 0) {
            currentScrollPos += originalSetWidth;
          }

          wrapper.scrollLeft = currentScrollPos;
        } else {
          currentScrollPos = wrapper.scrollLeft;
        }

        animationFrameId = requestAnimationFrame(loop);
      }

      animationFrameId = requestAnimationFrame(loop);

      // Hover pause / resume on desktop
      wrapper.addEventListener('mouseenter', () => {
        isPaused = true;
      });

      wrapper.addEventListener('mouseleave', () => {
        isPaused = false;
      });

      // Pointer / Touch / Swipe handling
      let startX = 0;
      let dragDist = 0;
      let isDragging = false;

      wrapper.addEventListener('pointerdown', (e) => {
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        isInteracting = true;
        isDragging = false;
        startX = e.clientX;
        dragDist = 0;
        if (resumeTimer) clearTimeout(resumeTimer);
      }, { passive: true });

      window.addEventListener('pointermove', (e) => {
        if (!isInteracting) return;
        const dx = e.clientX - startX;
        dragDist += Math.abs(dx);
        if (dragDist > 6) {
          isDragging = true;
        }
      }, { passive: true });

      function endInteraction() {
        if (!isInteracting) return;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          isInteracting = false;
          isDragging = false;
        }, 1200);
      }

      window.addEventListener('pointerup', endInteraction, { passive: true });
      window.addEventListener('pointercancel', endInteraction, { passive: true });

      wrapper.addEventListener('touchstart', () => {
        isInteracting = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      }, { passive: true });

      wrapper.addEventListener('touchend', () => {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          isInteracting = false;
        }, 1200);
      }, { passive: true });

      wrapper.addEventListener('scroll', () => {
        if (originalSetWidth > 0) {
          if (wrapper.scrollLeft >= originalSetWidth * 1.95) {
            wrapper.scrollLeft -= originalSetWidth;
            currentScrollPos = wrapper.scrollLeft;
          } else if (wrapper.scrollLeft <= 2) {
            wrapper.scrollLeft += originalSetWidth;
            currentScrollPos = wrapper.scrollLeft;
          }
        }
      }, { passive: true });

      // Click prevention only if user actually dragged/swiped
      track.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  // --- Testimonials ("Happy Customer") Infinite Auto-Slider ---
  function initTestimonialsSlider() {
    const sections = document.querySelectorAll('.testimonials-section');

    sections.forEach(section => {
      const wrapper = section.querySelector('.js-testimonials-wrapper');
      const track = section.querySelector('.js-testimonials-track');
      if (!wrapper || !track) return;

      // Clean up previous clones if re-initialized
      track.querySelectorAll('.is-clone').forEach(el => el.remove());

      const originalItems = Array.from(track.querySelectorAll('.testimonial-card'));
      if (originalItems.length === 0) return;

      // Hide scrollbars programmatically
      wrapper.style.scrollbarWidth = 'none';

      // Clone items to provide smooth buffer for infinite loop
      for (let c = 0; c < 2; c++) {
        originalItems.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          const cloneLink = clone.tagName === 'A' ? clone : clone.querySelector('a');
          if (cloneLink) cloneLink.setAttribute('tabindex', '-1');
          track.appendChild(clone);
        });
      }

      let originalSetWidth = 0;

      function measureWidth() {
        const firstClone = track.querySelector('.is-clone');
        if (firstClone && originalItems[0]) {
          originalSetWidth = firstClone.offsetLeft - originalItems[0].offsetLeft;
        } else {
          originalSetWidth = originalItems.reduce((acc, el) => acc + el.offsetWidth + 24, 0);
        }
      }

      measureWidth();
      window.addEventListener('resize', measureWidth, { passive: true });
      window.addEventListener('load', measureWidth, { passive: true });

      let currentScrollPos = wrapper.scrollLeft;
      let isPaused = false;
      let isInteracting = false;
      let resumeTimer = null;
      const speed = 0.55; // Gentle, elegant drift speed
      let animationFrameId = null;

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function loop() {
        if (!isPaused && !isInteracting && !prefersReducedMotion && originalSetWidth > 0) {
          currentScrollPos += speed;

          if (currentScrollPos >= originalSetWidth) {
            currentScrollPos -= originalSetWidth;
          } else if (currentScrollPos < 0) {
            currentScrollPos += originalSetWidth;
          }

          wrapper.scrollLeft = currentScrollPos;
        } else {
          currentScrollPos = wrapper.scrollLeft;
        }

        animationFrameId = requestAnimationFrame(loop);
      }

      animationFrameId = requestAnimationFrame(loop);

      // Hover pause / resume on desktop
      wrapper.addEventListener('mouseenter', () => {
        isPaused = true;
      });

      wrapper.addEventListener('mouseleave', () => {
        isPaused = false;
      });

      // Pointer / Touch / Swipe handling
      let startX = 0;
      let dragDist = 0;
      let isDragging = false;

      wrapper.addEventListener('pointerdown', (e) => {
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        isInteracting = true;
        isDragging = false;
        startX = e.clientX;
        dragDist = 0;
        if (resumeTimer) clearTimeout(resumeTimer);
      }, { passive: true });

      window.addEventListener('pointermove', (e) => {
        if (!isInteracting) return;
        const dx = e.clientX - startX;
        dragDist += Math.abs(dx);
        if (dragDist > 6) {
          isDragging = true;
        }
      }, { passive: true });

      function endInteraction() {
        if (!isInteracting) return;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          isInteracting = false;
          isDragging = false;
        }, 1500);
      }

      window.addEventListener('pointerup', endInteraction, { passive: true });
      window.addEventListener('pointercancel', endInteraction, { passive: true });

      wrapper.addEventListener('touchstart', () => {
        isInteracting = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      }, { passive: true });

      wrapper.addEventListener('touchend', () => {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(() => {
          isInteracting = false;
        }, 1500);
      }, { passive: true });

      wrapper.addEventListener('scroll', () => {
        if (originalSetWidth > 0) {
          if (wrapper.scrollLeft >= originalSetWidth * 1.95) {
            wrapper.scrollLeft -= originalSetWidth;
            currentScrollPos = wrapper.scrollLeft;
          } else if (wrapper.scrollLeft <= 2) {
            wrapper.scrollLeft += originalSetWidth;
            currentScrollPos = wrapper.scrollLeft;
          }
        }
      }, { passive: true });

      track.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }



  // ============================================================
  // COLLECTION PAGE
  // Sort + Price Filter + Items + Grid + Filter Drawer
  // NO PAGE REFRESH
  // ============================================================

  function initCollectionPage() {

    /* ==========================================================
       ELEMENTS
    ========================================================== */

    const grid =
      document.querySelector('.js-product-grid') ||
      document.querySelector('#product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('[data-product-grid]') ||
      document.querySelector('.collection__products .grid') ||
      document.querySelector('.collection .grid');


    const sortSelect =
      document.querySelector('.js-sort-select');


    const paginateSelect =
      document.querySelector('.js-paginate-select');


    const viewBtns =
      document.querySelectorAll('.js-view-btn');


    const filterToggleBtns =
      document.querySelectorAll('.js-toggle-filters');


    const filterSidebar =
      document.querySelector('.js-filter-sidebar') ||
      document.querySelector('.collection-filter-sidebar') ||
      document.querySelector('.collection-filters') ||
      document.querySelector('.facets-wrapper') ||
      document.querySelector('.facets-container') ||
      document.querySelector('.facets');


    const filterForm =
      document.querySelector('.js-filter-form') ||
      document.querySelector('form[data-filter-form]') ||
      document.querySelector('.facets form');


    const priceMinInput =
      document.querySelector(
        'input[name="filter.v.price.gte"]'
      ) ||
      document.querySelector('.js-price-min') ||
      document.querySelector('[data-price-min]');


    const priceMaxInput =
      document.querySelector(
        'input[name="filter.v.price.lte"]'
      ) ||
      document.querySelector('.js-price-max') ||
      document.querySelector('[data-price-max]');


    if (!grid) {
      console.warn('Product grid not found.');
      return;
    }


    grid.classList.add('js-product-grid');


    /* ==========================================================
       GET ACTUAL PRODUCT CARDS
    ========================================================== */

    function getProducts() {

      let products = Array.from(
        grid.querySelectorAll(
          ':scope > .grid__item, ' +
          ':scope > .product-grid__item, ' +
          ':scope > .product-card-wrapper, ' +
          ':scope > .product-card'
        )
      );


      if (!products.length) {

        products =
          Array.from(grid.children).filter(function (item) {

            return (
              item.nodeType === 1 &&
              !item.classList.contains('pagination') &&
              !item.classList.contains('facets-container')
            );

          });

      }


      return products;
    }


    const originalProducts =
      getProducts().slice();


    /* ==========================================================
       GET DISCOUNTED / CURRENT PRICE
  
       Example:
       $32.90
       $19.74
  
       Result = 19.74
    ========================================================== */

    function getProductPrice(product) {

      /*
       * First look specifically for sale/current price.
       */
      const salePriceEl =
        product.querySelector('.price-item--sale') ||
        product.querySelector('.price__sale .price-item') ||
        product.querySelector('[data-sale-price]');


      if (salePriceEl) {

        const saleText =
          salePriceEl.textContent || '';


        const saleMatch =
          saleText.match(
            /\$\s*([\d,]+(?:\.\d{1,2})?)/
          );


        if (saleMatch) {

          const saleValue =
            parseFloat(
              saleMatch[1].replace(/,/g, '')
            );


          if (!isNaN(saleValue)) {
            return saleValue;
          }

        }

      }


      /*
       * Otherwise read ALL dollar prices inside card.
       * Only dollar amounts are considered.
       *
       * This avoids "40% OFF" becoming a price.
       */
      const cardText =
        product.textContent || '';


      const matches =
        Array.from(
          cardText.matchAll(
            /\$\s*([\d,]+(?:\.\d{1,2})?)/g
          )
        );


      const prices =
        matches
          .map(function (match) {

            return parseFloat(
              match[1].replace(/,/g, '')
            );

          })
          .filter(function (price) {

            return (
              !isNaN(price) &&
              price > 0
            );

          });


      /*
       * Discounted price is lower than compare-at price.
       */
      if (prices.length) {

        return Math.min.apply(
          null,
          prices
        );

      }


      /*
       * Last fallback.
       */
      if (
        product.dataset &&
        product.dataset.price
      ) {

        let fallback =
          parseFloat(
            product.dataset.price
          );


        /*
         * Some themes store cents:
         * 1974 = $19.74
         */
        if (
          fallback > 500 &&
          Number.isInteger(fallback)
        ) {
          fallback =
            fallback / 100;
        }


        if (!isNaN(fallback)) {
          return fallback;
        }

      }


      return null;
    }


    /* ==========================================================
       PRODUCT TITLE
    ========================================================== */

    function getProductTitle(product) {

      const title =
        product.querySelector('.product-card__title') ||
        product.querySelector('.card__heading') ||
        product.querySelector('.product-title') ||
        product.querySelector('.full-unstyled-link') ||
        product.querySelector('[data-product-title]') ||
        product.querySelector('h3') ||
        product.querySelector('h2');


      return title
        ? title.textContent
          .trim()
          .toLowerCase()
        : '';

    }


    /* ==========================================================
       CURRENT PRICE RANGE
    ========================================================== */

    function getPriceRange() {

      let minPrice = 0;
      let maxPrice = Infinity;


      if (
        priceMinInput &&
        priceMinInput.value.trim() !== ''
      ) {

        minPrice =
          parseFloat(
            priceMinInput.value
          );


        if (isNaN(minPrice)) {
          minPrice = 0;
        }

      }


      if (
        priceMaxInput &&
        priceMaxInput.value.trim() !== ''
      ) {

        maxPrice =
          parseFloat(
            priceMaxInput.value
          );


        if (isNaN(maxPrice)) {
          maxPrice = Infinity;
        }

      }


      return {
        min: minPrice,
        max: maxPrice
      };
    }


    /* ==========================================================
       PRODUCT LIMIT
    ========================================================== */

    function getProductLimit() {

      if (!paginateSelect) {
        return Infinity;
      }


      const value =
        parseInt(
          paginateSelect.value,
          10
        );


      return isNaN(value)
        ? Infinity
        : value;
    }


    /* ==========================================================
       APPLY EVERYTHING
  
       Price filter + Items per page
    ========================================================== */

    function refreshProducts() {

      const products = getProducts();

      const range = getPriceRange();

      const limit = getProductLimit();

      const availabilityInputs =
        document.querySelectorAll(
          '.js-availability-filter:checked'
        );

      const selectedAvailability =
        Array.from(availabilityInputs)
          .map(function (input) {
            return input.dataset.availability;
          });


      let matchedCount = 0;
      let displayedCount = 0;


      products.forEach(function (product) {

        /* =========================
           PRICE
        ========================== */

        const price =
          getProductPrice(product);

        let matchesPrice = true;

        if (price !== null) {

          matchesPrice =
            price >= range.min &&
            price <= range.max;

        }


        /* =========================
           AVAILABILITY
        ========================== */

        let matchesAvailability = true;

        if (selectedAvailability.length) {

          /*
           * Try common sold-out markers
           */

          const cardText =
            (product.textContent || '')
              .toLowerCase();


          const soldOutElement =
            product.querySelector(
              '.sold-out,' +
              '.badge--sold-out,' +
              '[data-sold-out="true"],' +
              '[data-available="false"]'
            );


          const isSoldOut =
            !!soldOutElement ||
            cardText.includes('sold out');


          const isAvailable =
            !isSoldOut;


          matchesAvailability = false;


          if (
            selectedAvailability.includes('in-stock') &&
            isAvailable
          ) {

            matchesAvailability = true;

          }


          if (
            selectedAvailability.includes('out-of-stock') &&
            isSoldOut
          ) {

            matchesAvailability = true;

          }

        }


        /* =========================
           FINAL MATCH
        ========================== */

        const matches =
          matchesPrice &&
          matchesAvailability;


        if (!matches) {

          product.style.display = 'none';
          return;

        }


        matchedCount++;


        if (displayedCount < limit) {

          product.style.display = '';
          displayedCount++;

        } else {

          product.style.display = 'none';

        }

      });


      /* UPDATE COUNT */

      const count =
        document.querySelector(
          '.collection-toolbar__count strong'
        );


      if (count) {

        count.textContent =
          matchedCount;

      }

    }
    /* ==========================================================
       APPLY FILTER BUTTON
    ========================================================== */

    const applyFiltersBtn =
      document.querySelector('.js-apply-filters');

    if (
      applyFiltersBtn &&
      !applyFiltersBtn.dataset.filterInit
    ) {

      applyFiltersBtn.dataset.filterInit =
        'true';

      applyFiltersBtn.addEventListener(
        'click',
        function (e) {

          e.preventDefault();

          refreshProducts();

        }
      );

    }


    /* ==========================================================
       AVAILABILITY FILTER
    ========================================================== */

    document
      .querySelectorAll('.js-availability-filter')
      .forEach(function (input) {

        if (
          input.dataset.availabilityInit
        ) {
          return;
        }

        input.dataset.availabilityInit =
          'true';

        input.addEventListener(
          'change',
          refreshProducts
        );

      });


    if (
      filterForm &&
      !filterForm.dataset.submitInit
    ) {
      filterForm.dataset.submitInit = 'true';
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        refreshProducts();
      });
    }

    const resetFiltersBtn =
      document.querySelector('.js-reset-filters');

    if (
      resetFiltersBtn &&
      !resetFiltersBtn.dataset.resetInit
    ) {

      resetFiltersBtn.dataset.resetInit =
        'true';


      resetFiltersBtn.addEventListener(
        'click',
        function (e) {
          if (e) e.preventDefault();

          if (priceMinInput) {
            priceMinInput.value = '';
          }

          if (priceMaxInput) {
            priceMaxInput.value = '';
          }


          document
            .querySelectorAll(
              '.js-availability-filter'
            )
            .forEach(function (input) {

              input.checked = false;

            });


          refreshProducts();

        }
      );

    }

    /* ==========================================================
       SORT
       Uses DISCOUNT PRICE
    ========================================================== */

    if (
      sortSelect &&
      !sortSelect.dataset.collectionSortInit
    ) {

      sortSelect.dataset.collectionSortInit =
        'true';


      sortSelect.addEventListener(
        'change',
        function () {

          const value =
            this.value;


          let products =
            getProducts().slice();


          /* PRICE LOW TO HIGH */

          if (
            value === 'price-ascending'
          ) {

            products.sort(
              function (a, b) {

                const priceA =
                  getProductPrice(a);

                const priceB =
                  getProductPrice(b);


                return (
                  (priceA === null ? Infinity : priceA) -
                  (priceB === null ? Infinity : priceB)
                );

              }
            );

          }


          /* PRICE HIGH TO LOW */

          else if (
            value === 'price-descending'
          ) {

            products.sort(
              function (a, b) {

                const priceA =
                  getProductPrice(a);

                const priceB =
                  getProductPrice(b);


                return (
                  (priceB === null ? -Infinity : priceB) -
                  (priceA === null ? -Infinity : priceA)
                );

              }
            );

          }


          /* A-Z */

          else if (
            value === 'title-ascending'
          ) {

            products.sort(
              function (a, b) {

                return getProductTitle(a)
                  .localeCompare(
                    getProductTitle(b)
                  );

              }
            );

          }


          /* Z-A */

          else if (
            value === 'title-descending'
          ) {

            products.sort(
              function (a, b) {

                return getProductTitle(b)
                  .localeCompare(
                    getProductTitle(a)
                  );

              }
            );

          }


          /* FEATURED */

          else if (
            value === 'manual'
          ) {

            products =
              originalProducts.slice();

          }


          products.forEach(
            function (product) {

              grid.appendChild(product);

            }
          );


          refreshProducts();

        }
      );

    }


    /* ==========================================================
       PRICE FILTER
    ========================================================== */

    if (
      priceMinInput &&
      !priceMinInput.dataset.collectionPriceInit
    ) {

      priceMinInput.dataset.collectionPriceInit =
        'true';


      priceMinInput.addEventListener(
        'input',
        refreshProducts
      );


      priceMinInput.addEventListener(
        'change',
        refreshProducts
      );

    }


    if (
      priceMaxInput &&
      !priceMaxInput.dataset.collectionPriceInit
    ) {

      priceMaxInput.dataset.collectionPriceInit =
        'true';


      priceMaxInput.addEventListener(
        'input',
        refreshProducts
      );


      priceMaxInput.addEventListener(
        'change',
        refreshProducts
      );

    }


    /* ==========================================================
       PREVENT PRICE FILTER FORM PAGE REFRESH
    ========================================================== */

    if (
      filterForm &&
      !filterForm.dataset.collectionFilterFormInit
    ) {

      filterForm.dataset.collectionFilterFormInit =
        'true';


      filterForm.addEventListener(
        'submit',
        function (e) {

          e.preventDefault();

          refreshProducts();

        }
      );

    }


    /* ==========================================================
       ITEMS PER PAGE
    ========================================================== */

    /* Global event listener for ITEMS per page dropdown */
    document.addEventListener('change', function (e) {
      const select = e.target.closest('.js-paginate-select') || e.target.closest('#PaginateSelect');
      if (!select) return;
      const val = select.value;
      const url = new URL(window.location.href);
      url.searchParams.set('paginate', val);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    /* Preserve paginate parameter when clicking pagination links */
    document.addEventListener('click', function (e) {
      const link = e.target.closest('.collection-pagination a');
      if (!link) return;
      const select = document.querySelector('.js-paginate-select') || document.querySelector('#PaginateSelect');
      if (select && select.value) {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('paginate', select.value);
          e.preventDefault();
          window.location.href = url.toString();
        } catch (err) {}
      }
    });


    /* ==========================================================
       GRID VIEW
    ========================================================== */

    function setGridView(view) {

      grid.classList.remove(
        'product-grid--4col',
        'product-grid--3col',
        'product-grid--list',
        'product-grid--grid-4',
        'product-grid--grid-3',
        'product-grid--list-view'
      );


      if (
        view === '4col' ||
        view === 'grid-4'
      ) {

        grid.classList.add(
          'product-grid--4col'
        );

        view = '4col';

      }


      else if (
        view === '3col' ||
        view === 'grid-3'
      ) {

        grid.classList.add(
          'product-grid--3col'
        );

        view = '3col';

      }


      else {

        grid.classList.add(
          'product-grid--list'
        );

        view = 'list';

      }


      viewBtns.forEach(
        function (button) {

          button.classList.toggle(
            'active',
            button.dataset.view === view
          );

        }
      );


      try {

        localStorage.setItem(
          'babygoat_grid_layout',
          view
        );

      } catch (e) { }

    }


    viewBtns.forEach(
      function (button) {

        if (
          button.dataset.collectionViewInit
        ) {
          return;
        }


        button.dataset.collectionViewInit =
          'true';


        button.addEventListener(
          'click',
          function (e) {

            e.preventDefault();

            setGridView(
              this.dataset.view
            );

          }
        );

      }
    );


    let savedView = '4col';


    try {

      savedView =
        localStorage.getItem(
          'babygoat_grid_layout'
        ) || '4col';

    } catch (e) { }


    setGridView(savedView);


    /* ==========================================================
       FILTER BUTTON
    ========================================================== */

    filterToggleBtns.forEach(
      function (button) {

        if (
          button.dataset.collectionFilterToggleInit
        ) {
          return;
        }


        button.dataset.collectionFilterToggleInit =
          'true';


        button.addEventListener(
          'click',
          function (e) {

            e.preventDefault();


            if (filterSidebar) {

              filterSidebar.classList.toggle(
                'active'
              );

              filterSidebar.classList.toggle(
                'is-active'
              );


              document.body.classList.toggle(
                'collection-filters-open'
              );


              return;

            }


            const nativeFilterButton =
              document.querySelector(
                '.mobile-facets__open'
              ) ||
              document.querySelector(
                '.facets__open'
              );


            if (
              nativeFilterButton &&
              nativeFilterButton !== button
            ) {

              nativeFilterButton.click();

            }

          }
        );

      }
    );


    /* ==========================================================
       INITIAL RUN
    ========================================================== */

    refreshProducts();

  }

  // --- Product Page Interactive Features (Gallery, Variants, Quantity, Buy Now) ---
  function initProductPage() {
    const mainImg = document.getElementById('MainProductImage');
    const thumbBtns = document.querySelectorAll('.js-thumb-btn');
    const optionBtns = document.querySelectorAll('.js-option-btn');
    const variantsSelect = document.getElementById('ProductVariantsSelect');
    const selectedVariantInput = document.getElementById('SelectedVariantId');
    const priceEl = document.getElementById('CurrentPrice');
    const addToCartBtn = document.getElementById('AddToCartBtn');
    const addToCartText = document.getElementById('AddToCartText');
    const buyNowBtn = document.querySelector('.js-buy-now');
    const qtyInput = document.getElementById('ProductQuantity');
    const qtyMinus = document.querySelector('.js-qty-minus');
    const qtyPlus = document.querySelector('.js-qty-plus');

    // 1. Thumbnail Gallery Switcher
    if (mainImg && thumbBtns.length > 0) {
      thumbBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          const newSrc = this.getAttribute('data-image-src');
          if (newSrc) {
            mainImg.src = newSrc;
            thumbBtns.forEach(b => b.classList.remove('active'));
            this.classList.add('active');
          }
        });
      });
    }

    // 2. Quantity Stepper
    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', () => {
          let val = parseInt(qtyInput.value) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', () => {
          let val = parseInt(qtyInput.value) || 1;
          qtyInput.value = val + 1;
        });
      }
    }

    // 3. Variant Options Swatches & Buttons
    if (optionBtns.length > 0 && variantsSelect) {
      optionBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          const group = this.closest('.variant-option-group');
          if (group) {
            group.querySelectorAll('.js-option-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
          }

          // Update option labels
          const pos = this.getAttribute('data-option-position');
          const val = this.getAttribute('data-option-value');
          if (pos == '1') {
            const colorLabel = document.getElementById('SelectedColorLabel');
            if (colorLabel) colorLabel.textContent = val;
          } else if (pos == '2') {
            const sizeLabel = document.getElementById('SelectedSizeLabel');
            if (sizeLabel) sizeLabel.textContent = val;
          }

          // Match active options with variant dropdown options
          const selectedOptions = Array.from(document.querySelectorAll('.js-option-btn.active')).map(b => b.getAttribute('data-option-value'));

          let matchedOption = null;
          Array.from(variantsSelect.options).forEach(opt => {
            const opt1 = opt.getAttribute('data-option1');
            const opt2 = opt.getAttribute('data-option2');
            const opt3 = opt.getAttribute('data-option3');

            let matches = true;
            if (selectedOptions[0] && opt1 !== selectedOptions[0]) matches = false;
            if (selectedOptions[1] && opt2 !== selectedOptions[1]) matches = false;
            if (selectedOptions[2] && opt3 !== selectedOptions[2]) matches = false;

            if (matches) matchedOption = opt;
          });

          if (matchedOption) {
            const varId = matchedOption.value;
            const price = matchedOption.getAttribute('data-price');
            const isAvailable = matchedOption.getAttribute('data-available') === 'true';
            const imgUrl = matchedOption.getAttribute('data-image');

            if (selectedVariantInput) selectedVariantInput.value = varId;
            if (priceEl && price) priceEl.textContent = price;

            if (imgUrl && mainImg) {
              mainImg.src = imgUrl;
            }

            if (addToCartBtn) {
              if (isAvailable) {
                addToCartBtn.removeAttribute('disabled');
                if (addToCartText) addToCartText.textContent = `ADD TO CART — ${price}`;
                if (buyNowBtn) buyNowBtn.removeAttribute('disabled');
              } else {
                addToCartBtn.setAttribute('disabled', 'disabled');
                if (addToCartText) addToCartText.textContent = 'SOLD OUT';
                if (buyNowBtn) buyNowBtn.setAttribute('disabled', 'disabled');
              }
            }
          }
        });
      });
    }

    // 4. BUY IT NOW Button Direct Checkout
    if (buyNowBtn && selectedVariantInput) {
      buyNowBtn.addEventListener('click', function () {
        const varId = selectedVariantInput.value;
        const qty = qtyInput ? qtyInput.value : 1;
        if (varId) {
          window.location.href = `/cart/${varId}:${qty}`;
        }
      });
    }
  }

  // --- Sticky Header Scroll Shadow ---
  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  // --- Smart Shuffle and De-clustering for Product Grids ---
  function initProductGridShuffle() {
    const grids = document.querySelectorAll('.product-grid');
    if (!grids.length) return;

    // Respect explicit sorting by price or title if chosen by the user
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const sortVal = urlParams.get('sort_by');
      if (sortVal && !['manual', 'featured', 'best-selling', ''].includes(sortVal)) {
        return;
      }
    } catch (e) {}

    function getDesignKey(title) {
      if (!title) return '';
      const quoteMatch = title.match(/["'“"‘’]([^"'“"‘’]{4,})["'“"‘’]/);
      if (quoteMatch && !/^\s*(main role|cute|greatness|little size|on the go)/i.test(quoteMatch[1])) {
        return quoteMatch[1].toLowerCase().trim();
      }
      const clean = title
        .replace(/(toddler|youth|baby|infant|kids|heavy cotton|heavy blend|short sleeve|long sleeve|hooded|pullover|sweatshirt|t-shirt|tee|bodysuit|onesie|apparel|fleece|girls|classic)/gi, '')
        .replace(/[^a-zA-Z0-9\s]/g, ' ')
        .trim()
        .toLowerCase();
      const words = clean.split(/\s+/).filter(w => w.length > 2 && !['the', 'and', 'for', 'with', 'mode', 'goat'].includes(w));
      return words.slice(0, 2).join(' ');
    }

    grids.forEach(grid => {
      if (
        grid.dataset.noShuffle === 'true' ||
        grid.hasAttribute('data-no-shuffle') ||
        grid.closest('[data-no-shuffle="true"]') ||
        window.location.pathname.includes('halloween')
      ) {
        return;
      }
      const cards = Array.from(grid.querySelectorAll(':scope > .product-card'));
      if (cards.length < 3) return;

      const items = cards.map(card => {
        const titleEl = card.querySelector('.product-card__title a, .product-card__title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        return { card, title, key: getDesignKey(title) };
      });

      // Deterministic separation: if adjacent items have identical keys, swap duplicate into the second half
      const half = Math.floor(items.length / 2);
      for (let i = 0; i < items.length - 1; i++) {
        const keyI = items[i].key;
        const keyNext = items[i + 1].key;
        
        if (keyI && keyI === keyNext) {
          let targetIdx = -1;
          for (let offset = 0; offset < items.length; offset++) {
            const candidateIdx = (i + 1 + half + offset) % items.length;
            if (candidateIdx !== i && candidateIdx !== i + 1) {
              const candidateKey = items[candidateIdx].key;
              const prevKey = items[i].key;
              const afterKey = (i + 2 < items.length) ? items[i + 2].key : null;

              if (candidateKey !== prevKey && candidateKey !== afterKey) {
                targetIdx = candidateIdx;
                break;
              }
            }
          }

          if (targetIdx !== -1) {
            const temp = items[i + 1];
            items[i + 1] = items[targetIdx];
            items[targetIdx] = temp;
          }
        }
      }

      // Re-append cards in the new shuffled order
      const fragment = document.createDocumentFragment();
      items.forEach(item => fragment.appendChild(item.card));
      grid.appendChild(fragment);
      grid.dataset.shuffled = 'true';
    });
  }

  // --- Product Card Color Swatches (Hover / Click to switch image) ---
  function initProductCardSwatches() {
    function handleSwatch(e) {
      const dot = e.target.closest('.js-swatch-dot');
      if (!dot) return;
      const newSrc = dot.dataset.swatchSrc;
      if (!newSrc) return;
      const card = dot.closest('.product-card');
      if (!card) return;
      const primaryImg = card.querySelector('.product-card__image--primary');
      if (primaryImg) {
        primaryImg.src = newSrc;
        primaryImg.removeAttribute('srcset');
      }
    }

    document.addEventListener('mouseover', handleSwatch);
    document.addEventListener('click', handleSwatch);
  }

  // --- Initialize everything on DOM ready ---
  document.addEventListener('DOMContentLoaded', () => {
    initMobileNav();
    initStickyHeader();
    initSlideshow();
    initCarousels();
    initCategoryStripSlider();
    initTestimonialsSlider();
    initCart();
    initCollectionPage();
    initProductPage();
    initProductCardSwatches();
    initProductGridShuffle();
  });

  // Reinitialize on Shopify theme section change
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('category-strip') || e.target.querySelector('.category-strip')) {
      initCategoryStripSlider();
    }
    if (e.target.classList.contains('testimonials-section') || e.target.querySelector('.testimonials-section')) {
      initTestimonialsSlider();
    }
    initCollectionPage();
    initProductPage();
    initProductGridShuffle();
  });
})();


